import React from "react";
import Field from "../../../components/Fields/Field";
import { FieldProps } from "../../../components/Fields/Types";
import CodeTaskControl from "./CodeTaskControl";
import CodeTaskParameterInfo from "../../../models/CodeTaskParameterInfo";

export interface UserDefinedFieldProps extends FieldProps {
    codeTaskParamterInfo: CodeTaskParameterInfo
}

const UserDefinedField: React.FC<UserDefinedFieldProps> = ({ labelProps, controlProps, visible, disabled, codeTaskParamterInfo }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <CodeTaskControl controlProps={controlProps} codeTaskParamterInfo={codeTaskParamterInfo} disabled={disabled} />
        </Field>
    );
}
export default UserDefinedField;